import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { formatLocalDateTime } from "utils/formatLocalDateTime";

import ReasonColumn from "../ReasonColumn/ReasonColumn";

// A pending request has no decision yet, so reviewed_by / reviewed_at /
// action_reason are always null for it — the column only has something to show
// on the Approved, Rejected and All views.
export const showReviewedByColumn = (statusFilter) => statusFilter !== "pending";

// Who decided the request, when, and the admin's note. Every part can be null on a
// decided row, so each line only renders when it has something to show.
const ReviewedByCell = ({ request }) => {
  const { status, reviewed_by: reviewedBy, reviewed_at: reviewedAt, action_reason: actionReason } = request;

  // Pending rows can still appear on the "All" view.
  if (status === "pending") {
    return <span style={{ fontSize: "0.8rem", color: "#999" }}>—</span>;
  }

  return (
    <Box sx={{ minWidth: 0, width: "100%", py: 0.5 }}>
      <Tooltip title={reviewedBy || "—"} placement="top" arrow enterDelay={400}>
        <Typography noWrap sx={{ fontSize: "0.8rem", color: "#1a1a1a" }}>
          {reviewedBy || "—"}
        </Typography>
      </Tooltip>
      {reviewedAt && <Typography sx={{ fontSize: "0.7rem", color: "#888" }}>{formatLocalDateTime(reviewedAt)}</Typography>}
      {/* The admin's note can be long, so it gets the same 2-line clamp and "See more" as the Reason column. */}
      {actionReason && (
        <Box sx={{ borderLeft: "2px solid #d6d6d6", pl: 0.75, mt: 0.25 }}>
          <ReasonColumn compact params={{ row: { reason: actionReason } }} />
        </Box>
      )}
    </Box>
  );
};

export default ReviewedByCell;
